const read_access_token = (token = '') => {
    return String(token || '').trim().replace(/^Bearer\s+/i, '').trim();
};

export const read_bearer_authorization = (token = '') => {
    const accessToken = read_access_token(token);

    return accessToken ? `Bearer ${accessToken}` : '';
};

export const read_token_payload = (token = '') => {
    try {
        const payload = read_access_token(token).split('.')[1] || '';
        const normalizedPayload = payload.replace(/-/g, '+').replace(/_/g, '/');
        const paddedPayload = normalizedPayload.padEnd(Math.ceil(normalizedPayload.length / 4) * 4, '=');
        const jsonPayload = decodeURIComponent(window.atob(paddedPayload).split('').map((character) => {
            return `%${(`00${character.charCodeAt(0).toString(16)}`).slice(-2)}`;
        }).join(''));

        return JSON.parse(jsonPayload);
    } catch (error) {
        return {};
    }
};

export const read_token_expiration = (token = '') => {
    const expiration = Number(read_token_payload(token)?.exp);

    return Number.isFinite(expiration) && expiration > 0 ? expiration : null;
};

export const read_is_token_current = (token = '', nowMilliseconds = Date.now()) => {
    const accessToken = read_access_token(token);

    if (!accessToken) {
        return false;
    }

    const expiration = read_token_expiration(accessToken);

    return expiration === null || expiration * 1000 > nowMilliseconds;
};

export const read_has_live_keycloak_session = (keycloakInstance = {}, user = null, persistedToken = '') => {
    const keycloakToken = keycloakInstance?.token || '';

    if (
        !keycloakInstance?.authenticated
        || !user
        || !read_is_token_current(keycloakToken)
        || !read_is_token_current(persistedToken)
    ) {
        return false;
    }

    const identityValues = [
        read_token_payload(keycloakToken)?.sub,
        read_token_payload(persistedToken)?.sub,
        user?.sub
    ].map((value) => `${value || ''}`.trim()).filter(Boolean);

    return identityValues.length < 2 || identityValues.every((value) => value === identityValues[0]);
};
